import Image from '@next/image';

import { Employee as EmployeeType } from 'types/models/Employee';
import Link from '@components/atoms/Link';
import Typography from '@components/atoms/Typography';
import formatPhone from 'utils/formatPhone';

import classes from './Employee.module.scss';

type Props = {
  employee: EmployeeType;
};

const Employee = ({ employee }: Props) => {
  const { avatar, address } = employee;
  const [prefix, phone] = address.phone?.split(' ') || [];

  return (
    <div className={classes.wrapper}>
      <Image
        layout="fill"
        objectFit="contain"
        height={80}
        width={80}
        alt={address.fullName || ''}
        className={classes.avatar}
        resolveConfig={{
          preset: 'avatar',
          extension: avatar.extension,
          name: avatar.basename,
          width: avatar.width,
          height: avatar.height,
          productName: 'employee',
        }}
        hasIncreasedDensity={false} // todo 2x and 120px
      />
      <div className={classes.info}>
        <div>
          <Typography variant="h2" renderAs="div">
            {employee.address.fullName}
          </Typography>
          <Typography variant="body2" className={classes.position}>
            {employee.employeePosition?.name}
          </Typography>
        </div>
        <Typography variant="body1" renderAs="div">
          {!!phone && (
            <Link href={`tel:${address.phone?.replace(' ', '')}`} className={classes.link} underline="hover">
              {formatPhone(phone, 'mobile', prefix)}
            </Link>
          )}
          {!!address.email && (
            <Link href={`mailto:${address.email}`} className={classes.link} underline="hover">
              {address.email}
            </Link>
          )}
        </Typography>
      </div>
    </div>
  );
};

export default Employee;
